module.exports = __webpack_public_path__ + "img/451.6b12d461.jpg";